import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useTranslations } from "@jti/ui";
import styles from "./SubscriptionBenefits.module.scss";
export const SubscriptionBenefits = () => {
    const { __ } = useTranslations();
    const benefits = [];
    for (let i = 1; i <= 5; i++) {
        const benefit = __(`summarySubscription.benefit${i}`);
        if (benefit) {
            benefits.push(_jsx("li", { children: benefit }, i));
        }
    }
    if (!benefits.length)
        return null;
    return (_jsx("div", { className: classNames(styles.section, styles.sectionBenefits), children: _jsx("ol", { className: styles.benefitsList, children: benefits }) }));
};
//# sourceMappingURL=SubscriptionBenefits.js.map